import _ from 'lodash'

export default (originalArray, newArray, newAtTheEnd = false) => {
  return _.sortBy(
    newArray, (a) => {
      const index = _.findIndex(originalArray, (b) => b.id === a.id)

      if (index === -1) {
        return newAtTheEnd ? 9999 : -1
      } else {
        return index
      }
    }
  )
}
